import { render, staticRenderFns } from "./setting-join-index.vue?vue&type=template&id=4963cd0b&"
import script from "./setting-join-index.vue?vue&type=script&lang=js&"
export * from "./setting-join-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports